// extracted by mini-css-extract-plugin
module.exports = {"inner":"loading2_inner_1yi07","bg":"loading2_bg_3aMYC","img":"loading2_img_29SDE"};